var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSudan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.58763 9.07808C0.5705 11.1816 0 13.5414 0 16.0346C0 18.5278 0.5705 20.8876 1.58763 22.9911L16 24.3824L30.4124 22.9911C31.4295 20.8876 32 18.5278 32 16.0346C32 13.5414 31.4295 11.1816 30.4124 9.07808L16 7.68677L1.58763 9.07808Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.58813 22.9909C4.17601 28.3429 9.65657 32.0344 15.9999 32.0344C22.3433 32.0344 27.8239 28.3429 30.4118 22.9909H1.58813Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.58813 9.07768H30.4118C27.8239 3.72574 22.3433 0.0341797 15.9999 0.0341797C9.65657 0.0341797 4.17601 3.72574 1.58813 9.07768Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68677 4.71999C-1.56161 10.9684 -1.56161 21.0991 4.68677 27.3475C7.26883 24.7654 9.75214 22.2821 16.0005 16.0337L4.68677 4.71999Z",
    fill: "#496E2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53772"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0341797)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSudan);
export default __webpack_public_path__ + "static/media/sudan.6779d6d3.svg";
export { ForwardRef as ReactComponent };